import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';
import * as fromRules from './reducer';
import { FieldStoreState } from '../shared-store/field-store';

export const getRulesState = createFeatureSelector<State>('rule');
export const getFieldsState = createFeatureSelector<FieldStoreState.State>('field');

export const getRules = createSelector(getRulesState,
  (state: State) => fromRules.selectAll(state));

export const getRulesSearchText = createSelector(getRulesState,
    (state: State) => state.searchText);

export const getRulesJoinFields = createSelector(
    getRules,
    getFieldsState,
    getRulesSearchText,
    (rules, fieldState, searchText) => {
      const fieldsMap = fieldState.entities;
      if (rules && fieldsMap) {
      return rules.map(rule => {
        if (fieldsMap[rule.triggerFieldId]?.label.toLowerCase().includes(searchText.toLowerCase()) ||
        fieldsMap[rule.actionFieldId]?.label.toLowerCase().includes(searchText.toLowerCase()) ) {
          const ruleWithFields = { ...rule };
          ruleWithFields.triggerField = fieldsMap[rule.triggerFieldId];
          ruleWithFields.actionField = fieldsMap[rule.actionFieldId];
          return ruleWithFields;
        }
        else{
          return null;
        }
      });
    } else {
      return [];
    }
  }
  );
